module.exports = __webpack_public_path__ + "img/034-storm-10.db62f166.svg";